import { z } from 'zod'

import { UserWithMeta } from 'src/common-services'

export const promoCodeSchema = z.enum([
  'BRKR',
  // 'OWNR',
  // 'INVR',
  // 'DVLP',
])

export const webSignUpSchema = z.object({
  firstName: z.string().min(2).max(50),
  lastName: z.string().min(2).max(50),
  email: z.string().email(),
  password: z.string().min(6).max(50),
  token: z.string().min(1),
  code: z.optional(z.literal(promoCodeSchema.Values.BRKR)),
})

export type WebSignUpRequest = z.infer<typeof webSignUpSchema>
export type WebSignUpResponse = UserWithMeta
